import angular from 'angular';
import moment from 'moment';
import dateFormatService from '@/shared/services/DateFormatService';

angular
  .module('cxSettings')
  .controller('CompanyHolidaysDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'dataCache',
    'dialogsSvc',
    'ModalService',
    'companyId',
    companyHolidaysDialogCtrl,
  ]);

function companyHolidaysDialogCtrl(
  $element,
  $http,
  appUrls,
  flySvc,
  close,
  dataCache,
  dialogsSvc,
  ModalService,
  companyId,
) {
  var vm = this;
  const currentYear = moment.utc().year();
  vm.years = [currentYear - 1, currentYear, currentYear + 1, currentYear + 2];
  vm.year = currentYear;

  var retrieveHolidays = () => {
    vm.loading = true;
    $http.get(`${appUrls.api}/api/companyholiday/${companyId}/${vm.year}`).then(
      ({ data }) => {
        vm.loading = false;
        vm.holidays = data;
      },
      error => {
        vm.loading = false;
        flySvc.error(error);
      },
    );
  };
  retrieveHolidays();

  vm.yearChanged = () => {
    retrieveHolidays();
  };

  vm.openCreateHolidayDialog = () => {
    ModalService.showModal({
      template: require('./addCompanyHolidayDialog.html'),
      controller: 'AddCompanyHolidayDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        companyId: companyId,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });

      modal.close.then(function(result) {
        if (!result) return;
        vm.holidays = result;
      });
    });
  };

  vm.deleteHoliday = holiday => {
    const formattedDate = dateFormatService.formatDateLong(holiday.date);

    dialogsSvc
      .showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteHoliday', { date: formattedDate })
      .then(function() {
        $http
          .delete(appUrls.api + '/api/companyholiday/' + holiday.id)
          .then(function(response) {
            var result = response.data;
            var index = vm.holidays.indexOf(holiday);
            if (index >= 0) {
              vm.holidays.splice(index, 1);
            }
          })
          .catch(function(error) {
            flySvc.error(error);
            return '';
          });
      });
  };

  vm.save = function() {
    close(null, 500);
    $element.modal('hide');
  };

  vm.cancel = function() {
    close(null, 500);
    $element.modal('hide');
  };
}
